import React from 'react';
import { isNativeApp } from '../utils/platform';
import { secondaryButtonStyle } from '../shared/secondaryButton';

function TeamBillingCard({ copy, colors, onManageBilling, note, isDark }) {
  if (!copy || copy.audience === 'solo') return null;
  return (
    <div style={{
      background: colors.surfaceAlt || 'rgba(89, 196, 196, 0.1)',
      border: `1px solid ${colors.border}`,
      borderRadius: '8px',
      padding: '1rem',
      marginBottom: '1rem',
    }}>
      <p style={{ margin: 0, fontWeight: 650, color: colors.text }}>{copy.title}</p>
      {note ? (
        <p style={{ margin: '0.5rem 0 0', color: colors.textSecondary, fontSize: '0.9rem' }}>{note}</p>
      ) : null}
      {copy.showManageBilling && !isNativeApp() && (
        <button
          type="button"
          onClick={onManageBilling}
          style={{
            marginTop: '0.75rem',
            minHeight: '44px',
            padding: '0.65rem 1rem',
            borderRadius: '0.75rem',
            ...secondaryButtonStyle(isDark),
            fontWeight: 650,
            cursor: 'pointer',
          }}
        >
          Manage Billing
        </button>
      )}
    </div>
  );
}

export default TeamBillingCard;
